/*
 * F2a · Vuelta del login «con escritura»: antes de ir a Meta se marca en sessionStorage; al
 * volver, la página del callback adapta el mensaje del 409 META_PERMISSION_MISSING y el panel
 * abre ⚙ Configuración de Meta (una sola vez). Sin sessionStorage (modo privado), no pasa nada.
 */
const KEY = 'terrio.metaWriteReturn';

const storage = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
};

export function markMetaWriteReturn() {
  try { storage()?.setItem(KEY, '1'); } catch { /* sin storage */ }
}

export function peekMetaWriteReturn() {
  try { return storage()?.getItem(KEY) === '1'; } catch { return false; }
}

/** Lee y borra la marca. */
export function consumeMetaWriteReturn() {
  const marked = peekMetaWriteReturn();
  try { storage()?.removeItem(KEY); } catch { /* sin storage */ }
  return marked;
}
